import {create} from "zustand";

const useUserAuthenticatedStore = create((set) => ({
    isUserAuthenticated: null,

    setUserAuthenticated: (data) => set({isUserAuthenticated: data}),
}));

export default useUserAuthenticatedStore